<template>
<div class="modal" tabindex="-1" id="edit-course-modal">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header bg-custom">
                <div class="row">
                    <h3> Edit/Create a &nbsp;Course</h3>
                </div> <div class="row">
                <button type="button" @click="cancel" class="close" title="Close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                </div>
            </div>
            <div class="modal-body">
                <div class="row" >
                <h5 class="modal-title text-bold">Course:</h5>
                    <div class="col">
                    <h2 class="bg-secondary text-center" v-if="coursedata" v-html="'<strong>Course:</strong> ' + (coursedata.name?coursedata.name:'(New)')"></h2>
                    <div style="visibility:block;">
                    <input type="text" v-model="coursedata.name" placeholder="Course Name"/>
 <input type="text" v-model="coursedata.slug" placeholder="Slug"/>
                    <input  type="text" v-model="coursedata.byline" placeholder="Course Byline"/>
 <input type="text" v-model="coursedata.image_url" placeholder="Image URL"/>
                    <!-- <input v-model="coursedata.id" type="hidden"/> -->
                    </div>
 <button class="btn btn-lg btn-warning float-right mx-2 my-2" @click="cancel">Close</button>
 <button class="btn btn-lg btn-primary float-right  mx-2 my-2" @click="saveCourseAction">Save All</button>
                    </div>
                </div>
             </div></div></div></div>

</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import EventBus from '../../../event-bus';
// import Editor from '@tinymce/tinymce-vue';


import { v4 as uuidv4 } from 'uuid';

export default {
    components: {
     },
    name: "ManageCourse",
    data() {
        return {
            csrf_token: document.head.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            userinfo:'',
            coursedata:{},
            lessoncat:{},
            lessoncatData:'',
        }
    },

    props: {
        user:'',
        courses:'',
        apikey:'',
    },
    mounted() {
          this.userinfo = JSON.parse(this.user);
            EventBus.$on('showNewCourseModal', (data) => {
            console.error(" coursemanage::cr new course.");
            // this.modalReset();
            $('div#edit-course-modal').modal('show');
        });

        EventBus.$on('editCourseModal', (data) => {
            this.coursedata = Object.assign({}, data.course);
            $('div#edit-course-modal').modal('show');
        });

    },


    methods: {
setSelLessonCat() {
},
saveCourseAction() {
            axios.post('/edu/courses/saveupdate', {
                owner_id:this.userinfo.id,
                id:this.coursedata.id,
                name:this.coursedata.name,
                byline:this.coursedata.byline,
                image_url:this.coursedata.image_url,
                slug:this.coursedata.slug
            })
            .then(res => {
                this.loading = false;
                this.success = true;
                this.message = res.data.message;
                this.updateToast(this.message, 4000);
                console.error(res.data.message);
                this.coursedata = JSON.parse(res.data.course);
                EventBus.$emit('refreshParentPage');
            })
            .catch(err => {
                // this.loading = false;
                // this.failure = true;
                // this.success = false;
                console.error(err);
                this.updateToast(err.message, 4000, 'error');
            })
            .finally(()=> {
                // location.reload();
            });

        },
saveLessonCatAction() {
},
         getGUID() {
            var guid = uuidv4();
            // console.log("GUID: " + guid);
            return guid;
        },
        modalReset() {
            //set all fields to blank
            this.coursedata.id = '';
            this.coursedata.name = '';
            this.coursedata.byline = '';
            this.coursedata.image_url = '';
            this.coursedata.owner_id = '';
            this.coursedata.slug = '';
        },
        cancelLessonCat() {
            console.log("Cancel close FSLifeArea");
            $('div#edit-course-modal').modal('hide');
            EventBus.$emit('refreshParentPage');
            // location.reload();
        },
        getTemplate(life_area) {
             console.log("Looking for template with id " + life_area);
            return this.templates.find((template) =>{
                    // console.log(life_area + ' : '+ template.life_area);
                if(template.life_area == life_area) {
                    // console.log("Found template...");
                    return template;
                }
            });
        },
        getInitMenuPlugins() {
            return {
                height: 200,
                menubar: false,
                plugins: [
                    'code table lists'
                ],
                toolbar:
                    'undo redo | formatselect | bold italic backcolor | \
                    alignleft aligncenter alignright alignjustify | \
                    bullist numlist outdent indent | removeformat | help'
            }
        },
        saveAction() {
            this.saveDetails();
        },


        updateToast(message, timer = 2000, icon='success') {
            const Toast = Swal.mixin({
                position: 'center',
                width: 500,
                showConfirmButton: true,
            });
            Toast.fire({
                icon: icon,
                title: message
            });
        },
cancel() {
    // EventBus.$emit('refreshParentPage');
   $('div#edit-course-modal').modal('hide');
}

    },
    computed: {
    },
}
</script>
<style>
.bg-custom{
    background: #449acb;
color: #fff;
}
</style>
